import React from 'react';
import { Download, X } from 'lucide-react';
import type { Entorno } from '../utils/detectarPlataforma';
import { textoDeInvitacion } from '../utils/invitacionInstalacion';

interface InstalarAppBannerProps {
  readonly entorno: Entorno;
  readonly onInstalar: () => void;
  readonly onCerrar: () => void;
}

export const InstalarAppBanner: React.FC<InstalarAppBannerProps> = ({
  entorno,
  onInstalar,
  onCerrar,
}) => {
  const { mensaje, rotuloBoton } = textoDeInvitacion(entorno);

  return (
    <div className="flex items-center gap-3 px-4 py-2 bg-blue-50 border-t border-blue-100 lg:px-6">
      <Download className="w-4 h-4 text-blue-600 flex-shrink-0" aria-hidden="true" />
      <p className="flex-1 min-w-0 text-sm text-slate-700">{mensaje}</p>
      <button
        type="button"
        onClick={onInstalar}
        className="flex-shrink-0 text-sm font-medium text-blue-600 hover:text-blue-700 underline underline-offset-2 active:scale-[0.98] transition-colors"
      >
        {rotuloBoton}
      </button>
      <button
        type="button"
        onClick={onCerrar}
        aria-label="Cerrar el aviso de instalación"
        className="flex-shrink-0 p-1 rounded-lg hover:bg-blue-100 transition-colors"
      >
        <X className="w-4 h-4 text-slate-500" />
      </button>
    </div>
  );
};
